export default __webpack_public_path__ + "static/media/blue-circle.19072a4e.png";